module.exports = __webpack_public_path__ + "focuse_icon.62a0bd76.png";